import { Spin } from 'antd';
import { PropsWithChildren } from 'react';
import style from './LoadingWrapper.module.less';

interface LoadingWrapperProps extends Omit<Partial<HTMLDivElement>, 'children'> {
  loading?: boolean;
}

const LoadingWrapper:React.FC<LoadingWrapperProps & PropsWithChildren> = props => {
  return (
    <div className={`${style.loadingWrapper} ${props.loading ? style.loading : ''}`}>
      {props.children}
      {
        props.loading && <div className={style.spin}>
          <Spin spinning={true}></Spin>
        </div>
      }
    </div>
  );
};

export default LoadingWrapper;
